export function getDistinctValues<T>(array: T[]): T[]
{
  //https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
  return array.filter((value, index, array) => array.indexOf(value) === index)
}
